import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ConnectedProps, useSelector } from "react-redux";
import { Button, Typography, Row, Col, Avatar } from "antd";

import CompanyStructureItems from "../../../assets/images/company-structure-items/company-structure-items";
import testLogo from "../../../assets/images/company-structure-items/companyInfo.svg";
import CreateEntityInfo from "../../shared/CreateEntityInfo";
import { selectUser } from "../../../redux/auth/selector";
import connector from "./Container";
import CompanyInfoEdit from "./EditCompanyInfo";

const { Text } = Typography;
const cloudfrontKey = process.env.REACT_APP_CLOUDFRONT_KEY;

const CompanyInfoScreen = (props: ConnectedProps<typeof connector>) => {
  const {
    companyInfo,
    actions: { adminGetCompanyInfoById, adminEditCompanyInfo, setCurrentStep },
  } = props;

  const [isEditing, setIsEditing] = useState(false);
  const user = useSelector(selectUser);
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentStep({ steps: 4, currentStep: 1 });
    const id = user?.companyId;
    id && !companyInfo && adminGetCompanyInfoById({ id });
  }, [user]);

  return (
    <Row className="h-full pb-[40px]">
      <Col lg={8}>
        <CreateEntityInfo
          title={!isEditing ? "" : "Hello,"}
          text={
            <>
              <div className="mb-6">
                {!isEditing
                  ? "Here is the Company’s information."
                  : "To start using our educational app let’s define the basic information about the Company."}
              </div>
              <div>
                {!isEditing
                  ? "Please note that only Admin can edit the info."
                  : "You can update the information at any time."}
              </div>
            </>
          }
        />
      </Col>
      <Col lg={16} className="gap-4 h-full flex flex-col max-w-[600px]">
        <div>
          {!isEditing ? (
            <div className="bg-white shadow-md rounded-lg p-5 flex flex-col">
              <div className="flex justify-between items-center mb-6">
                <div className="flex gap-4">
                  <CompanyStructureItems.Step1 />
                  <Text className="text-neutral-600 font-normal text-lg">
                    Company Info
                  </Text>
                </div>
                <Button
                  type="link"
                  onClick={() => setIsEditing(true)}
                  className="text-primary-600 font-semibold text-sm pr-0 pl-2"
                >
                  Edit
                </Button>
              </div>
              <Text className="text-neutral-600 font-semibold text-sm">
                Company Name
              </Text>
              <div className="h-[50px] bg-neutral-100 flex items-center px-4 text-neutral-600 font-semibold text-base rounded-lg mt-4 mb-6">
                {companyInfo?.name}
              </div>
              <div className="h-[100px] flex justify-between">
                <Text className="text-neutral-600 font-semibold text-sm">
                  Company Logotype
                </Text>
                <Avatar
                  size={100}
                  className="shadow-md border border-neutral-200"
                  src={
                    companyInfo?.imageKey
                      ? `${cloudfrontKey}/${companyInfo?.imageKey}`
                      : testLogo
                  }
                ></Avatar>
              </div>
              <Text className="text-neutral-600 font-semibold text-sm">
                Notification for passive users
              </Text>
              <div className="min-h-[50px] bg-neutral-100 flex items-center px-4 py-3 text-neutral-600 font-semibold text-base rounded-lg mt-4 mb-6">
                {companyInfo?.notificationText &&
                  companyInfo?.notificationText !== "null" &&
                  companyInfo?.notificationText}
              </div>
            </div>
          ) : (
            <CompanyInfoEdit
              companyInfo={companyInfo}
              setIsEditing={setIsEditing}
              editCompanyInfo={adminEditCompanyInfo}
            />
          )}
        </div>

        {!isEditing && (
          <div className="flex justify-end gap-10">
            <Button
              className="w-1/2 bg-primary-600 text-white 		font-semibold text-sm h-[50px]"
              onClick={() => navigate("/admin/department")}
            >
              Continue
            </Button>
          </div>
        )}
      </Col>
    </Row>
  );
};

export default CompanyInfoScreen;
